export default "__VITE_ASSET__VsH_cuLQ__"